export default __webpack_public_path__ + "static/media/exit.3ddc87ee.svg";